/**
 * Stored somewhere coastal by somebody who did not intend to come back for it.
 */

import type { Affix } from '@/sim/items/affixContract';

export const SALT_CORROSION = {
  id: 'saltCorrosion',
  slot: 'suffix',
  field: 'damage',
  direction: -1,
  label: 'Reduced damage',
  nameWord: 'of Salt Corrosion',
  ranges: {
    common: { min: 0.03, max: 0.06 },
    uncommon: { min: 0.05, max: 0.09 },
    rare: { min: 0.08, max: 0.13 },
    exotic: { min: 0.11, max: 0.17 },
  },
} as const satisfies Affix;
